<div
  class="fixed left-0 right-0 top-0 z-50 flex h-[calc(100%-1rem)] max-h-full w-full animate-fadeUp items-center justify-center overflow-y-auto overflow-x-hidden duration-500 md:inset-0"
  id="default-modal">
  <div
    class="fixed bottom-0 h-[90vh] w-[100vw] overflow-hidden rounded-t-[10px] bg-white md:relative md:h-auto md:w-full md:max-w-[800px] md:bg-transparent">
    <!-- Modal content -->
    <div class="relative bg-white md:rounded-[24px]">
      <!-- Modal header -->
      <div class="p-6">
        <div class="flex items-center">
          <button (click)="closeModal()" class="mr-6" app-icon-button name="x" size="sm"></button>
          <ng-content select="[header]"></ng-content>
        </div>
        <p class="prose prose-display-lg mt-6 font-semibold">{{ title }}</p>
        <p class="mt-3 text-sm text-neutral-500">{{ subTitle }}</p>
      </div>
      <!-- Modal body -->
      <div class="px-6 pt-3">
        <ng-content select="[body]"></ng-content>
      </div>
      <!-- Modal footer -->
      <div class="w-full px-6">
        <ng-content select="[footer]"></ng-content>
      </div>
    </div>
  </div>
</div>
<div class="fixed inset-0 z-40 bg-black bg-opacity-50"></div>
